import { useInView } from "react-intersection-observer"

const InViewContainer = ({ options = {}, className = "", children }) => {
  const [inViewRef, isInView, inViewEl] = useInView(options)

  return (
    <div ref={inViewRef} className={className}>
      {children({
        inViewRef,
        isInView,
        inViewEl,
      })}
    </div>
  )
}

export default InViewContainer
